var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvasNavMoveAround = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 65,
    viewBox: "0 0 59 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.167969,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#9C64FF",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2841 14.7941H31.4478H43.9478C46.1569 14.7941 47.9478 16.585 47.9478 18.7941V32.7941C47.9478 35.0032 46.1569 36.7941 43.9478 36.7941H18.9478C16.7386 36.7941 14.9478 35.0032 14.9478 32.7941V25.7941V25.5012",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4145_3536)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_4145_3536",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8388 31.7459C38.49 31.6587 38.0872 31.5715 37.645 31.4862V22.2707C37.645 20.3377 36.078 18.7707 34.145 18.7707C33.0284 18.7707 32.0339 19.2936 31.393 20.1079C30.7521 19.2964 29.7593 18.7755 28.6449 18.7755C26.7119 18.7755 25.1449 20.3425 25.1449 22.2755V35.2136L23.8601 33.9288C22.4933 32.562 20.2772 32.562 18.9104 33.9288C17.5435 35.2957 17.5435 37.5117 18.9104 38.8786L27.7162 47.6844C28.9891 49.1345 31.1389 50.0232 34.7698 50.0232C43.6712 50.0232 44.1449 44.1267 44.1449 42.358L44.1449 37.6415C44.1449 34.4279 41.1971 32.3355 38.8388 31.7459Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8388 31.7459C38.49 31.6587 38.0872 31.5715 37.645 31.4862V22.2707C37.645 20.3377 36.078 18.7707 34.145 18.7707C33.0284 18.7707 32.0339 19.2936 31.393 20.1079C30.7521 19.2964 29.7593 18.7755 28.6449 18.7755C26.7119 18.7755 25.1449 20.3425 25.1449 22.2755V35.2136L23.8601 33.9288C22.4933 32.562 20.2772 32.562 18.9104 33.9288C17.5435 35.2957 17.5435 37.5117 18.9104 38.8786L27.7162 47.6844C28.9891 49.1345 31.1389 50.0232 34.7698 50.0232C43.6712 50.0232 44.1449 44.1267 44.1449 42.358L44.1449 37.6415C44.1449 34.4279 41.1971 32.3355 38.8388 31.7459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.645 31.4862H35.645V33.1371L37.2661 33.4499L37.645 31.4862ZM38.8388 31.7459L39.3239 29.8056L39.3239 29.8056L38.8388 31.7459ZM31.393 20.1079L29.8236 21.3475L31.3959 23.3382L32.9647 21.3448L31.393 20.1079ZM25.1449 35.2136L23.7307 36.6278L27.1449 40.042V35.2136H25.1449ZM23.8601 33.9288L22.4459 35.343H22.4459L23.8601 33.9288ZM18.9104 33.9288L17.4962 32.5146H17.4962L18.9104 33.9288ZM18.9104 38.8786L20.3246 37.4643H20.3246L18.9104 38.8786ZM27.7162 47.6844L29.2193 46.365L29.1764 46.3161L29.1304 46.2702L27.7162 47.6844ZM44.1449 42.358H46.1449V42.358L44.1449 42.358ZM44.1449 37.6415H42.1449V37.6416L44.1449 37.6415ZM37.2661 33.4499C37.6833 33.5304 38.0492 33.6101 38.3538 33.6862L39.3239 29.8056C38.9307 29.7073 38.491 29.6125 38.0239 29.5224L37.2661 33.4499ZM35.645 22.2707V31.4862H39.645V22.2707H35.645ZM34.145 20.7707C34.9734 20.7707 35.645 21.4422 35.645 22.2707H39.645C39.645 19.2331 37.1826 16.7707 34.145 16.7707V20.7707ZM32.9647 21.3448C33.2427 20.9916 33.6675 20.7707 34.145 20.7707V16.7707C32.3893 16.7707 30.8251 17.5956 29.8214 18.871L32.9647 21.3448ZM28.6449 20.7755C29.1215 20.7755 29.5456 20.9956 29.8236 21.3475L32.9625 18.8682C31.9586 17.5972 30.3971 16.7755 28.6449 16.7755V20.7755ZM27.1449 22.2755C27.1449 21.4471 27.8165 20.7755 28.6449 20.7755V16.7755C25.6073 16.7755 23.1449 19.238 23.1449 22.2755H27.1449ZM27.1449 35.2136V22.2755H23.1449V35.2136H27.1449ZM22.4459 35.343L23.7307 36.6278L26.5591 33.7994L25.2743 32.5146L22.4459 35.343ZM20.3246 35.343C20.9104 34.7572 21.8601 34.7572 22.4459 35.343L25.2743 32.5146C23.1265 30.3667 19.644 30.3667 17.4962 32.5146L20.3246 35.343ZM20.3246 37.4643C19.7388 36.8786 19.7388 35.9288 20.3246 35.343L17.4962 32.5146C15.3483 34.6625 15.3483 38.1449 17.4962 40.2928L20.3246 37.4643ZM29.1304 46.2702L20.3246 37.4643L17.4962 40.2928L26.302 49.0986L29.1304 46.2702ZM34.7698 48.0232C31.4326 48.0232 29.9594 47.2081 29.2193 46.365L26.2131 49.0038C28.0189 51.0609 30.8453 52.0232 34.7698 52.0232V48.0232ZM42.1449 42.358C42.1449 43.1035 42.0338 44.499 41.1771 45.6786C40.4064 46.7399 38.7381 48.0232 34.7698 48.0232V52.0232C39.7029 52.0232 42.7222 50.3582 44.4136 48.0291C46.0192 45.8183 46.1449 43.3812 46.1449 42.358H42.1449ZM42.1449 37.6416L42.1449 42.3581L46.1449 42.358L46.1449 37.6415L42.1449 37.6416ZM38.3538 33.6862C39.221 33.903 40.2268 34.4127 40.9853 35.1469C41.7236 35.8613 42.1449 36.6968 42.1449 37.6415H46.1449C46.1449 35.3727 45.0923 33.5551 43.7671 32.2725C42.4622 31.0097 40.8149 30.1784 39.3239 29.8056L38.3538 33.6862Z",
    fill: "#50307E",
    mask: "url(#path-3-inside-1_4145_3536)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4028 21.8175V33.8175",
    stroke: "#50307E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8179 14.7969L14.1469 14.7969M21.8179 14.7969L19.8179 12.7969M21.8179 14.7969L19.8179 16.7969",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.064 8L15.064 15.671M15.064 8L13.064 10M15.064 8L17.064 10",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.064 21.3281L15.064 13.6572M15.064 21.3281L17.064 19.3281M15.064 21.3281L13.064 19.3281",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38818 14.7969L16.0592 14.7969M8.38818 14.7969L10.3882 16.7969M8.38818 14.7969L10.3882 12.7969",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4145_3536",
    x: 11.8853,
    y: 12.7707,
    width: 46.2596,
    height: 51.2525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.188235 0 0 0 0 0.494118 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3536",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvasNavMoveAround);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas_nav_move_around.9708fbcbab53d4a9b275ef431350745d.svg";